<!-- 背景图片组件 -->
<template>
  <div class="backgroundone">
		<!-- 头部背景 -->
		<div class="topbagdiv">
			<img src="../../assets/images/topbag.jpg" />
		</div>
		<!-- 插槽 登录框 注册框等 -->
		<slot name="backgroundslot"></slot>
		<!-- 底部背景 -->
		<div class="botbagdiv">
			<img src="../../assets/images/bottombag.jpg" />
		</div>
		<!-- logo -->
		<img class="logo" src="../../assets/images/logo.png" />
  </div>
</template>

<script>
	export default {
	  name: 'Background_one',
		methods:{
			backhome(){
				this.$router.replace("./Home")
			}
		}
	}
</script>

<style scoped>
	
	@import url("../../assets/css/style.css");
	.backgroundone{
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}
	.backgroundone{
		background: url(../../assets/images/centerbag.jpg) repeat-y;
		background-size: 100%;
	}
	.backgroundone .topbagdiv img,.backgroundone .botbagdiv img{
		width: 100%;
		height: auto;
		display: block;
	}
	.backgroundone .topbagdiv{
		position: absolute;
		left: 0px;
		right: 0px;
		top: 0px;
		z-index: 1;
	}
	.backgroundone .botbagdiv{
		position: absolute;
		left: 0px;
		right: 0px;
		bottom: 0px;
		z-index: 1;
	}
	.backgroundone .logo{
		position: absolute;
		left: 6rem;
		top: 6rem;
		width: 18rem;
		height: auto;
		z-index: 2;
	}

</style>